import * as React from 'react';
import NavMenu from './NavMenu';
import { useAppContext } from '../../providers/AppContext';

export default function Layout({ children }: { children: React.ReactNode }) {
  const { isNavMinimized, isScrolled } = useAppContext();
  const offset = (isNavMinimized || isScrolled) ? '40px' : '50px';

  return (
    <div style={{ paddingTop: offset, transition: 'padding-top 0.25s ease-in-out' }}>
      <NavMenu />
      <div style={{ paddingTop: isNavMinimized ? '0px' : '20px' }}>
        {children}
      </div>
    </div>
  );
}
